// extracted by mini-css-extract-plugin
export default {"inputWithPostfix":"style_inputWithPostfix__L3Ztz","postfix":"style_postfix__A0oso","postfix_value":"style_postfix_value__pM6vE","postfix_sign":"style_postfix_sign__3LTG7"};